import React, { useContext, useEffect, useState } from "react";
import { Form, Input, Button, Checkbox, InputNumber } from "antd";
import { Container, Row, Col, Label } from "reactstrap";
import BackComponent from "../BackComponent";
import { UserContext } from "./UserContext";
import { useHistory, useParams } from "react-router-dom";
import Axios from "axios";

const SingleEditGamesComponent = () => {
  const [form] = Form.useForm();
  const [formLayout] = useState("horizontal");
  const { id } = useParams();
  const [user] = useContext(UserContext);
  const [data, setData] = useState(null);
  const history = useHistory();

  console.log(id);

  useEffect(() => {
    if (data === null) {
      Axios.get(`https://backendexample.sanbersy.com/api/data-game/${id}`).then(
        (res) => {
          form.setFieldsValue(res.data);
        }
      );
    }
  }, [data, setData, id]);

  const handleSubmit = (values) => {
    let singlePlayer = values.mode.includes("one") ? 1 : 0;
    let multiPlayer = values.mode.includes("two") ? 1 : 0;

    const newData = {
      name: values.name,
      genre: values.genre,
      singlePlayer: singlePlayer,
      multiplayer: multiPlayer,
      platform: values.platform,
      release: values.release,
      image_url: values.image_url,
    };

    console.log(values, "berhasil update");
    const url = `https://backendexample.sanbersy.com/api/data-game/${id}`;

    Axios.put(url, newData, {
      headers: { Authorization: `Bearer ${user.token}` },
    }).then((res) => {
      alert("Berhasil Update Data");
      history.push("/games");
      console.log(res.data);
    });
  };

  return (
    <Container>
      <Row>
        <Col md="8" className="mx-auto mt-5">
          <Form
            layout={formLayout}
            form={form}
            initialValues={{
              layout: formLayout,
            }}
            onFinish={handleSubmit}
          >
            <Form.Item label="Name" name="name">
              <Input placeholder="input Name" />
            </Form.Item>
            <Form.Item label="Genre" name="genre">
              <Input placeholder="input Genre" />
            </Form.Item>
            <Form.Item name="mode">
              <Checkbox.Group style={{ width: "100%" }}>
                <Row>
                  <Col span={8}>
                    <Label>SinglePlayer : </Label>
                    <Checkbox value="one" />
                  </Col>
                  <Col span={8}>
                    <Label>MultiPlayer : </Label>
                    <Checkbox value="two" />
                  </Col>
                </Row>
              </Checkbox.Group>
            </Form.Item>
            <Form.Item label="Platform" name="platform">
              <Input placeholder="input Platform" />
            </Form.Item>
            <Form.Item label="Release" name="release">
              <InputNumber placeholder="input Release" />
            </Form.Item>
            <Form.Item label="Image_Url" name="image_url">
              <Input placeholder="input Image_Url" />
            </Form.Item>
            <Button type="primary" htmlType="submit" className="primary mb-2">
              Update
            </Button>
            <BackComponent />
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default SingleEditGamesComponent;
